import { useEffect, useState } from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import useDrive from "../../hooks/useDrive";
import { UPLOAD_STATUS } from "../../config/appConst";

export default function ProgressSnack({ value, fileDetail }) {
    const { uploadStatus } = useDrive();
    const [progress, setProgress] = useState(0);

    useEffect(() => { setProgress(Math.round(value || 0)); }, [value]);

    const isOpen = uploadStatus === UPLOAD_STATUS.UPLOADING && fileDetail?.file_name;
    if (!isOpen) return null;

    const fileName = fileDetail.file_name || "";
    const shortName = fileName.length > 36 ? fileName.slice(0, 34) + "…" : fileName;

    return (
        <Box sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 2000,
            width: 320,
            bgcolor: "var(--bg-elevated)",
            border: "1px solid var(--border)",
            borderRadius: 3,
            boxShadow: "0 16px 48px rgba(0,0,0,0.2), 0 0 0 1px rgba(124,106,247,0.12)",
            overflow: "hidden",
        }}>
            {/* Top bar — progress stripe */}
            <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                    height: 3,
                    bgcolor: "var(--border)",
                    "& .MuiLinearProgress-bar": {
                        bgcolor: "#7c6af7",
                        backgroundImage: "linear-gradient(90deg, #e85878, #7c6af7)",
                        borderRadius: 0,
                        transition: "transform 0.3s ease",
                    },
                }}
            />

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, px: 2.5, py: 2 }}>
                {/* Icon */}
                <Box sx={{
                    width: 40, height: 40, flexShrink: 0, borderRadius: 2,
                    bgcolor: "rgba(124,106,247,0.15)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                }}>
                    <CloudUploadOutlinedIcon sx={{ fontSize: 22, color: "#7c6af7" }} />
                </Box>

                {/* Text */}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography sx={{ color: "var(--text-1)", fontWeight: 600, fontSize: 13, mb: 0.25 }}>
                        Uploading file
                    </Typography>
                    <Typography sx={{ color: "var(--text-3)", fontSize: 11, mb: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {shortName}
                    </Typography>

                    {/* Progress bar */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <LinearProgress
                            variant="determinate"
                            value={progress}
                            sx={{
                                flex: 1, height: 5, borderRadius: 3,
                                bgcolor: "var(--border)",
                                "& .MuiLinearProgress-bar": {
                                    bgcolor: "#7c6af7",
                                    backgroundImage: "linear-gradient(90deg, #e85878, #7c6af7)",
                                    borderRadius: 3,
                                    transition: "transform 0.3s ease",
                                },
                            }}
                        />
                        <Typography sx={{ color: "#7c6af7", fontWeight: 700, fontSize: 12, flexShrink: 0, minWidth: 32 }}>
                            {progress}%
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
